export default {
  inserted: (el, binding) => {
    const { value } = binding;

    el.addEventListener('click', () => {
      navigator.clipboard.writeText(value).then(
        () => {
          el.dispatchEvent(new CustomEvent('copy', { detail: true }));
        },
        () => {
          el.dispatchEvent(new CustomEvent('copy', { detail: false }));
        },
      );
    });
  },
};
